module.exports = __webpack_public_path__ + "img/icon-gen-vieworganiser.2ee56ebe.png";